import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.isTouch = window.matchMedia("(pointer: coarse)").matches
    this.closeTimeout = null

    this.boundCloseIfOutside = this.closeIfOutside.bind(this)
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
    this.boundOpenOnHover = this.openMenu.bind(this)
    this.boundScheduleClose = this.scheduleClose.bind(this)

    document.addEventListener("click", this.boundCloseIfOutside)
    document.addEventListener("keydown", this.boundCloseOnEscape)

    if (!this.isTouch) {
      this.element.addEventListener("mouseenter", this.boundOpenOnHover)
      this.element.addEventListener("mouseleave", this.boundScheduleClose)
      this.menuTarget?.addEventListener("mouseenter", this.boundOpenOnHover)
      this.menuTarget?.addEventListener("mouseleave", this.boundScheduleClose)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseIfOutside)
    document.removeEventListener("keydown", this.boundCloseOnEscape)

    if (!this.isTouch) {
      this.element.removeEventListener("mouseenter", this.boundOpenOnHover)
      this.element.removeEventListener("mouseleave", this.boundScheduleClose)
      this.menuTarget?.removeEventListener("mouseenter", this.boundOpenOnHover)
      this.menuTarget?.removeEventListener("mouseleave", this.boundScheduleClose)
    }
  }

  toggle(event) {
    if (event) event.stopPropagation()
    if (!this.hasMenuTarget) return

    if (this.isTouch) {
      this.menuTarget.classList.toggle("hidden")
    } else {
      this.openMenu()
    }
  }

  close(event) {
    if (event) event.stopPropagation()
    this.closeMenu()
  }

  closeIfOutside(event) {
    if (!this.hasMenuTarget) return
    if (this.element.contains(event.target)) return

    this.closeMenu()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return

    this.closeMenu()
  }

  closeMenu() {
    if (!this.hasMenuTarget) return

    this.clearCloseTimeout()
    this.menuTarget.classList.add("hidden")
  }

  openMenu() {
    if (!this.hasMenuTarget) return

    this.clearCloseTimeout()
    this.menuTarget.classList.remove("hidden")
  }

  scheduleClose() {
    this.clearCloseTimeout()
    this.closeTimeout = setTimeout(() => this.closeMenu(), 200)
  }

  clearCloseTimeout() {
    if (!this.closeTimeout) return

    clearTimeout(this.closeTimeout)
    this.closeTimeout = null
  }
}
